import { render } from "./TheFooter.vue?vue&type=template&id=3669d24a&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=3669d24a&scoped=true&lang=css"

import exportComponent from "/var/www/html/remote/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3669d24a"]])

export default __exports__